export default {
    OPEN_DOCUMENT_READONLY_MODE: "Открыть в режиме просмотра",
    OPEN_DOCUMENT_EDIT_MODE: "Открыть в режиме редактирования",
    DUPLICATE_DOCUMENT: "Дублировать",
    RENAME_DOCUMENT: "Переименовать",
    DELETE_DOCUMENT: "Удалить",
    CONFIRM_DELETE_DOCUMENT_TEXT: "Вы уверены, что хотите удалить этот документ?",
    CONFIRM_DELETE_DOCUMENT_HEADER: "Удалить документ"
};
